import type { IdZonaElevacaoPainel } from '../../dominio/didatico/elevacaoPainel'
import type { PerfilVeiculo } from '../../dominio/didatico/perfilVeiculo'
import type { IdPortaOficina } from './zonasOperacaoPorta'
import { pontosRebatimentoPainel } from './zonasRebatimentoPainel'

export function pontosElevacaoPainel(perfil: PerfilVeiculo, idPorta: IdPortaOficina, altura = 0, dobra = 0) {
  const { coluna, yMedio, sinal } = pontosRebatimentoPainel(perfil, idPorta)
  const yInferior = perfil.topoSoleiraY + 0.05
  const ySuperior = perfil.topoSoleiraY + 0.27
  const inferior = coluna(yInferior)
  const superior = coluna(ySuperior)
  const anguloDobra = Math.max(0, Math.min(1, dobra)) * Math.PI * 0.48
  const comprimentoAba = ySuperior - yInferior
  const dx = superior[0] - inferior[0]
  const pontaAba: [number, number, number] = [inferior[0] + dx * Math.cos(anguloDobra) + sinal * comprimentoAba * Math.sin(anguloDobra), inferior[1] - sinal * dx * Math.sin(anguloDobra) + comprimentoAba * Math.cos(anguloDobra), superior[2]]
  const apoioInferior: [number, number, number] = [superior[0], yInferior + 0.005, superior[2]]
  const apoioSuperior: [number, number, number] = [superior[0], ySuperior + 0.02 + altura, superior[2] + altura * 0.35]
  return { coluna, yMedio, sinal, yInferior, ySuperior, inferior, superior, pontaAba, anguloDobra, apoioInferior, apoioSuperior }
}

export function zonaElevacaoPorId(perfil: PerfilVeiculo, idPorta: IdPortaOficina, id: IdZonaElevacaoPainel, altura = 0, dobra = 0) {
  const p = pontosElevacaoPainel(perfil, idPorta, altura, dobra)
  const posicoes: Record<IdZonaElevacaoPainel, [number, number, number]> = {
    corteAElevacao: p.coluna(p.yMedio),
    corteBaseASuperior: p.superior,
    corteBaseAInferior: p.inferior,
    abaElevacao: p.pontaAba,
    apoioAlargadorPainel: p.apoioInferior.map((n, i) => (n + p.apoioSuperior[i]) / 2) as [number, number, number],
  }
  return { id, posicao: posicoes[id], anguloGraus: id.startsWith('corte') ? 90 : 0 }
}

/** Pose do modelo existente: escala fixa e pontas superiores/inferiores nos dois apoios. */
export function poseAlargadorElevacao(apoioInferior: [number, number, number], apoioSuperior: [number, number, number], sinal: number) {
  const escala = 0.9
  const dy = apoioSuperior[1] - apoioInferior[1]
  const dz = apoioSuperior[2] - apoioInferior[2]
  const giroX = Math.atan2(dz, dy)
  const meiaAbertura = Math.hypot(dy, dz) / (2 * escala)
  // Pivôs em (0,06; ±0,09), centro da ponta em (0,46; ±0,045).
  const raio = Math.hypot(0.46, 0.045)
  const theta = Math.asin(Math.max(-1, Math.min(1, (meiaAbertura - 0.09) / raio))) - Math.atan2(0.045, 0.46)
  const alcance = 0.06 + 0.46 * Math.cos(theta) - 0.045 * Math.sin(theta)
  const posicao: [number, number, number] = [apoioInferior[0] + sinal * alcance * escala, (apoioInferior[1] + apoioSuperior[1]) / 2, (apoioInferior[2] + apoioSuperior[2]) / 2]
  return { escala, anguloMandibula: theta + 0.28, posicao, giroX, giroY: sinal > 0 ? Math.PI : 0 }
}
